import { MissionData } from '../blocks/mission'
import template from './templates/RJF12.rbxl'
import thumbnail1 from './thumbnails/RJF12/Ball.png'
import thumbnail2 from './thumbnails/RJF12/BlueBlock.png'
import thumbnail3 from './thumbnails/RJF12/Keeper.png'
import thumbnail4 from './thumbnails/RJF12/YellowBar.png'
import thumbnail5 from './thumbnails/RJF12/PinkBar.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①ボール',
      thumbnail: thumbnail1,
    },
    {
      name: '②あおいブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③キーパー',
      thumbnail: thumbnail3,
    },
    {
      name: '④きいろいぼう',
      thumbnail: thumbnail4,
    },
    {
      name: '⑤ピンクのぼう',
      thumbnail: thumbnail5,
    },
  ],
}

export default mission
